import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Decimal } from 'decimal.js';
var UNITS = ['', 'тыс', 'млн', 'млрд'];
var D = Decimal.clone({
  rounding: Decimal.ROUND_HALF_CEIL
});
export function getFormattedNumber(d, options) {
  var unit = getUnit(d);
  var numD = d.toNumber();
  var resultDecimal = round(d);
  if (options.shortThousands && numD >= 1000 || !options.shortThousands && numD >= 1000000) {
    resultDecimal = truncate(resultDecimal, unit);
    return format(resultDecimal, unit, options);
  }
  return beautify(resultDecimal.toString());
}
export function getUnit(d) {
  var ln1k = new D(1000).ln();
  return d.ln().div(ln1k).floor().clamp(0, UNITS.length - 1);
}
export function truncate(value, unit) {
  var divider = new D(1000).pow(unit);
  return value.div(divider);
}

/**
 * Возвращает число от 0 до 2, которое связано с кол-вом разрядов исходного числа
 * @example
 * unitReminder(1000) -> 0
 * unitReminder(10000) -> 1
 * unitReminder(100000) -> 2
 * unitReminder(1000000) -> 0
 * */
export function unitReminder(d) {
  return d.log(10).mod(3).floor();
}

/**
 * Округляет число в зависимости от его значения
 * @example
 * round(560.45) -> 560
 * round(1560000) -> 1600000
 * */
export function round(d) {
  /** Числа до 1000 просто округляются до целого числа */
  if (d.toNumber() < 1000) {
    return d.round();
  }
  if (d.greaterThan(new D(1e12))) {
    return d.toSD(4);
  }

  /**
   * Округляет числа больше 1000 в зав-ти от кол-ва разрядов (см reminder)
   * Округляет до 3 или 2 значащих чисел.
   * */
  var reminder = unitReminder(d);
  return d.toSD(reminder.toNumber() ? 3 : 2);
}

/** Корректно работает только с целыми числами */
export function beautify(value) {
  return value.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
}
export function format(d, unit, options) {
  var unitName = UNITS[unit.toNumber()];
  return "".concat(d.toString().replace(/\./g, ',')).concat(options.showUnit && " ".concat(unitName) || '');
}
export var getPrettyPrice = function getPrettyPrice(price, options) {
  var _options = _objectSpread({
    showUnit: true,
    unit: '₽',
    sqr: false,
    showPostfix: true
  }, options);
  var unit = '';
  if (_options.showUnit) {
    unit = _options.sqr ? "".concat(_options.unit, "/\u043C\xB2") : _options.unit;
  }
  var d = new D(price);
  var formattedNumber = getFormattedNumber(d, _options);
  return "".concat(formattedNumber).concat(unit && " ".concat(unit));
};